"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = __importDefault(require("prop-types"));

var get_css_1 = __importDefault(require("../get-css"));

exports.propTypes = {
  opacity: prop_types_1["default"].oneOfType([prop_types_1["default"].string, prop_types_1["default"].number])
};
exports.propAliases = {};
exports.propValidators = {};
var _opacity = {
  className: 'opct',
  cssName: 'opacity',
  jsName: 'opacity',
  defaultUnit: ''
};
exports.propEnhancers = {
  opacity: function opacity(value) {
    return get_css_1["default"](_opacity, value);
  }
};